import {useContext, useEffect, useState} from 'react';
import api from 'services/api';
import config from 'config';
import CARDBOX from './components/box';
import {formatNumber} from 'components/formatos';
import {CidadeContext} from 'services/cidade';
import './style.css';
import ADSENSE from "../../../components/adsense";

function HomeAdmin() {
	const [dados, setDados] = useState([]);
	//const [lcampanhas, setlCampanhas] = useState([]);
	const [lvendas, setlVendas] = useState([]);
	const [lAnos, setlAnos] = useState([]);

	const {cod_cidade} = useContext(CidadeContext)

	useEffect(() => {
		api.get(`${config.ADM_DASHBOARD}?cod_cidade=${cod_cidade}`)
			.then(response => {
				setDados(response.data);
				setlVendas(response.data.vendas);
				const anosUnicos = [...new Set(response.data.vendas.map(venda => venda.ano))].sort((a, b) => b - a);
				setlAnos(anosUnicos);
			});
	}, [cod_cidade]);

	if (dados.estatisticas !== undefined) {
		return <div>

				<div className='dashboard-header mb-4'>
					<h2 className="section-title">Dashboard Administrativo</h2>
				</div>

				<div className="row g-3 mb-4">
					<div className='col-6 col-md-4 col-lg-2'>
						<CARDBOX
							header={'Online'}
							icon={'fas fa-broadcast-tower'}
							text={dados.estatisticas.online ?? 0}
						/>
					</div>
					<div className='col-6 col-md-4 col-lg-2'>
						<CARDBOX
							header={'Empresas'}
							icon={'fas fa-building'}
							text={dados.estatisticas.num_empresa ?? 0}
						/>
					</div>
					<div className='col-6 col-md-4 col-lg-2'>
						<CARDBOX
							header={'Ativos'}
							icon={'fas fa-user-check'}
							text={dados.estatisticas.num_ativos ?? 0}
						/>
					</div>
					<div className='col-6 col-md-4 col-lg-2'>
						<CARDBOX
							header={'Participantes'}
							icon={'fas fa-users'}
							text={dados.estatisticas.num_participantes ?? 0}
						/>
					</div>
					<div className='col-6 col-md-4 col-lg-2'>
						<CARDBOX
							header={'Usuários'}
							icon={'fas fa-user-friends'}
							text={dados.estatisticas.num_usuarios ?? 0}
						/>
					</div>
					<div className='col-6 col-md-4 col-lg-2'>
						<CARDBOX
							header={'Vendas'}
							icon={'fas fa-shopping-basket'}
							text={dados.estatisticas.num_vendas ?? 0}
						/>
					</div>
				</div>

				<div className='row g-3 mb-5'>
					<div className='col-12 col-md-6 col-lg-3'>
						<CARDBOX
							header={'Campanhas Ativas'}
							icon={'fas fa-bullhorn'}
							text={dados.estatisticas.num_campanha ?? 0}
						/>
					</div>
					<div className='col-12 col-md-6 col-lg-3'>
						<CARDBOX
							header={'Volume Total'}
							icon={'fas fa-hand-holding-usd'}
							text={`R$ ${formatNumber(dados.estatisticas.sum_vendas)}`}
						/>
					</div>
				</div>

				{lAnos.map((ano) => (
					<div key={ano} className="mb-5">
						<h3 className="section-title mb-4">{ano}</h3>
						<div className="row g-3">
							{lvendas.filter(v => v.ano === ano).map((v, index) => {
								return <div className='col-12 col-md-6 col-lg-4 col-xl-3' key={`camp${index}`}>
									<CARDBOX
										header={v.nom_estabelecimento}
										icon={'fas fa-store'}
										text={<div className="mt-2">
											<span className='linhas2-card'><i className="fas fa-ticket-alt"></i>Cupons: <strong>{v.nro_cupons}</strong></span>
											<span className='linhas2-card'><i className="fas fa-shopping-cart"></i>Vendas: <strong>{v.nro_vendas}</strong></span>
											<span className='linhas2-card'><i className="fas fa-money-bill-wave"></i>Total: <strong>R$ {formatNumber(v.total_venda)}</strong></span>
											<span className='linhas2-card'><i className="fas fa-chart-line"></i>Ticket: <strong>R$ {formatNumber(v.ticket_medio)}</strong></span>
										</div>}
									/>
								</div>
							})}
						</div>
					</div>
				))}

			<ADSENSE adClient="pub-6502602254112573" adSlot="922034089" style={{ display: 'block', marginBottom: '20px' }} />
			<ADSENSE adClient="pub-6502602254112573" adSlot="0987654321" style={{ display: 'block', marginTop: '20px' }} />
		</div>
	} else {
		<div></div>
	}

}
export default HomeAdmin;